<template>
  <q-fila v-if="aplica" :label="label" :ayuda="ayuda" :completa="respondida" :resaltar="resaltar">
    <input type="number" min="0" step="1" class="form-control" :placeholder="placeholder"
           :value="value" :disabled="soloLectura" @input="emitir($event.target.value)" />
    <small v-if="invalido" class="text-danger">Ingrese un número válido, sin decimales ni negativos.</small>
  </q-fila>
</template>

<script>
import QFila from "./QFila";

/** Cantidad entera no negativa. Se guarda como número, nunca como texto. */
export default {
  name: "QNumero",
  components: { QFila },
  props: {
    value: { default: null },
    label: { type: String, required: true },
    ayuda: { type: String, default: "" },
    placeholder: { type: String, default: "" },
    aplica: { type: Boolean, default: true },
    resaltar: { type: Boolean, default: true },
    soloLectura: { type: Boolean, default: false },
  },
  data() {
    return { invalido: false };
  },
  computed: {
    respondida() {
      return this.value !== null && this.value !== undefined && this.value !== "";
    },
  },
  methods: {
    emitir(bruto) {
      if (bruto === "" || bruto === null) {
        this.invalido = false;
        this.$emit("input", null);
        return;
      }
      const n = Number(bruto);
      this.invalido = !Number.isInteger(n) || n < 0;
      this.$emit("input", this.invalido ? null : n);
    },
  },
};
</script>
